<div #sidebar id="sidebar" *ngIf="ViewSidebar">
  <header class="site-header sticky-top">
    <section *ngIf="!powerMaster">
      <div class="logo">
        <a [routerLink]="'/' + shareModel.urlPath.Dashboard" (click)="defaultDashboard()">
          <span class="logo-icon"><img src="../assets/images/logo_icon.png"></span>
          <span class="logo-text" [ngClass]="{'pro': (isMspLoaded && isMsp) && !isSuperAdmin}">
            <img src="../assets/images/logo_text.png">
            <span class="badge badge-danger" *ngIf="(isMspLoaded && isMsp) && !isSuperAdmin">PRO</span>
          </span>
        </a>
        <div class="menu-button hidden-lg" (click)="mobilemenuBtn()">
          <a role="button" tabindex="0" style="cursor: pointer;">
            <i class="fa fa-bars" aria-hidden="true"></i>
          </a>
        </div>
      </div>
      <div class="menu-button hidden-sm" (click)="menuBtn()" *ngIf="menuControl">
        <a role="button" tabindex="0" style="cursor: pointer;">
          <i class="fa fa-bars" aria-hidden="true"></i>
        </a>
      </div>
    </section>
    <section *ngIf="powerMaster">
      <div class="menu-button hidden-sm" (click)="menuBtn()" *ngIf="menuControl">
        <a role="button" tabindex="0" style="cursor: pointer;">
          <i class="fa fa-bars" aria-hidden="true"></i>
        </a>
      </div>
      <div class="logo">
        <a [routerLink]="'/' + shareModel.urlPath.Dashboard">
          <span class="logo-icon"><img src="{{logoPath}}"></span>
        </a>
        <div class="menu-button hidden-lg" (click)="mobilemenuBtn()">
          <a role="button" tabindex="0" style="cursor: pointer;">
            <i class="fa fa-bars" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
    <div class="multiSelect">
      <p-multiSelect *ngIf="isMsp" [options]="mspCompanyOptions" (onPanelHide)="SelectByRegion()" [baseZIndex]="10000" [(ngModel)]="mspCompanySelected" [selectedItemsLabel]="'{0} ' + ('company selected' | translate)">
        <!-- <ng-template let-item pTemplate="item">
          <span>{{item.label}}</span>
        </ng-template> -->
      </p-multiSelect>
    </div>
    <div class="user">
      <!-- <p-splitButton label="{{ChangePasswordInfo.Account}}" [model]="items" class="hidden-sm"></p-splitButton> -->
      <!-- 小鈴鐺通知 -->
      <button type="button" pButton icon="fa fa-bell" (click)="op1.toggle($event);" class="user-button notifi" *ngIf="menuControl">
        <span class="badge-dot" *ngIf="showNewNotifi"></span>
      </button>
      <p-popover #op1 class="notifiBox" (onShow)="notifiBoxOnShow();">
        <div class="content-title">
          <h5 translate>Notifications</h5>
          <span class="badge badge-danger">{{notificationListCount}}</span>
        </div>
        <div class="content-body">
          <p-scrollPanel [style]="{width: '360px', height: '250px'}">
            <div class="content-Panel" *ngIf="notificationList.length <= 20 else notificationListVirtualScroll">
              <div class="list-group">
                <a class="list-group-item list-group-item-action" *ngFor="let item of notificationList ; let i=index;" (click)="op1.hide($event);updateNotificaitonList();"
                  [routerLink]="item.routeLink" [queryParams]="item.routeLink === '/gateway-setting' ? { tab: item.tab } : null">
                  <div class="media">
                    <span class="fa-stack fa-lg">
                      <i class="fa fa-circle fa-stack-2x"></i>
                      <i class="fa {{item.icon}} fa-stack-1x fa-inverse"></i>
                    </span>
                    <div class="media-body">
                      <h5><span class="badge badge-dark">{{item.deviceName}}</span>
                      {{item.title | translate:
                        {
                        'level': item.level,
                        'BHIStatus': item.BHIStatus|translate,
                        'expiredDay': item.expiredDay,
                        'DiscoveryJobName': item.discoveryJobName,
                        'GatewayName': item.gatewayName
                        }
                      }}</h5>
                      <p>{{item.description | translate: {'BHI': item.BHI} }}</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="content-Panel" *ngIf="notificationList.length == 0">
              <div class="list-group">
                <div class="no-data center">
                  <div>
                    <span class="fa-stack fa-lg">
                      <i class="fa fa-circle fa-stack-2x"></i>
                      <i class="fa fa-bell fa-stack-1x fa-inverse"></i>
                    </span>
                  </div>
                  <div translate>
                    No Notification
                  </div>
                </div>
              </div>
            </div>
          </p-scrollPanel>
          <ng-template #notificationListVirtualScroll>
            <div class="list-group" #notificationListScrollingBlock>
              <virtual-scroller #notificationScroll [items]="notificationList" [parentScroll]="notificationListScrollingBlock" [enableUnequalChildrenSizes]="true" [executeRefreshOutsideAngularZone]="true">
                <a class="list-group-item list-group-item-action {{i}}" *ngFor="let item of notificationScroll.viewPortItems ; let i=index;" (click)="op1.hide($event);updateNotificaitonList();"
                [routerLink]="item.routeLink" [queryParams]="item.routeLink === '/gateway-setting' ? { tab: item.tab } : null">
                <div class="media" *ngIf="!pageloading">
                  <span class="fa-stack fa-lg">
                    <i class="fa fa-circle fa-stack-2x"></i>
                    <i class="fa {{item.icon}} fa-stack-1x fa-inverse"></i>
                  </span>
                  <div class="media-body">
                    <h5><span class="badge badge-dark">{{item.deviceName}}</span> {{item.title | translate:
                        {
                        'level': item.level,
                        'BHIStatus': item.BHIStatus|translate,
                        'expiredDay': item.expiredDay,
                        'DiscoveryJobName': item.discoveryJobName,
                        'GatewayName': item.gatewayName
                        }
                      }}</h5>
                    <p>{{item.description | translate: {'BHI': item.BHI} }}</p>
                  </div>
                </div>
                <div class="media" *ngIf="pageloading">
                  <span class="fa-stack fa-lg">
                    <p-skeleton shape="circle" width="40px" height="40px"></p-skeleton>
                  </span>
                  <div class="media-body">
                    <h5><p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 14, 'background-color': '#e9eef0'}"></p-skeleton></h5>
                    <p><p-skeleton appearance="line" [theme]="{ 'width': '50%','height.px': 14, 'background-color': '#e9eef0'}"></p-skeleton></p>
                  </div>
                </div>
                </a>
              </virtual-scroller>
            </div>
          </ng-template>
        </div>
      </p-popover>
      <!-- 小鈴鐺通知 -->
      <button type="button" pButton icon="pi pi-angle-down" iconPos="right" label="{{ChangePasswordInfo.Account.split('@')[0]}}" (click)="menu.toggle($event)" class="user-button username">
        <span class="fa-stack">
          <i class="fa fa-circle fa-stack-2x"></i>
          <i class="fa-stack-1x name-avatar">{{ChangePasswordInfo.Account.substr(0,1)}}</i>
        </span>
      </button>
      <p-menu #menu [popup]="true" [model]="items" class="account-menu"></p-menu>
      <!-- <a href="#" (click)="showConfirmDialog()" class="hidden-lg hidden-md">
        <i class="fa fa-sign-out" aria-hidden="true"></i>
      </a> -->
    </div>
  </header>

  <aside *ngIf="asideView">
    <p-scrollPanel [style]="{width: '100%', height: scrollPanelHeight + 'px'}">
      <nav class="navigation" (window:resize)="onResize($event)">
        <div class="management" *ngIf="isSuperAdmin || (isAdmin && isMspLoaded && !isMsp)">
          <ul *ngIf="isAdmin" [ngClass]="showAdminHeader ? 'showAdminHeader' : 'hideAdminHeader'">
            <li class="navigation-header">
              <a data-bs-toggle="collapse" href="#collapseManagement" role="button" aria-expanded="true" aria-controls="collapseManagement">
                {{'Management'| translate}}
                <i class="fa fa-sort-desc" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
          <ul class="collapse show" id="collapseManagement">
            <!-- <li *ngIf="isAdmin" class="navigation-header">Management</li> -->
            <li *ngIf="isAdmin">
              <a [routerLink]="'/' + shareModel.urlPath.AccountManagement" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Account Management' | translate}}">
                <i class="fa fa-users" aria-hidden="true"></i>
                <span translate>Account Management</span>
              </a>
            </li>
            <li *ngIf="isAdmin && isSuperAdmin && !powerMaster">
              <a [routerLink]="'/' + shareModel.urlPath.PlanManagement" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Plan Management' | translate}}">
                <div class="fa-stack">
                  <i class="fa fa-file-o fa-stack-1x"></i>
                  <i class="fa fa-check fa-stack-1x"></i>
                </div>
                <span translate>Plan Management</span>
              </a>
            </li>
            <li *ngIf="isAdmin && isSuperAdmin">
              <a [routerLink]="'/' + shareModel.urlPath.Package" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Package Management' | translate}}">
                <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                <span translate>Package Management</span>
              </a>
            </li>
            <li *ngIf="(isAdmin && isMspLoaded && !isMsp ) || isSuperAdmin">
              <a [routerLink]="'/' + shareModel.urlPath['PaymentMgt']" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Payment Management' | translate}}">
                <i class="fa fa-credit-card" aria-hidden="true"></i>
                <span translate>Payment Management</span>
              </a>
            </li>
            <li *ngIf="(isAdmin && isMspLoaded && !isMsp) || isSuperAdmin else MspAdmin">
              <a [routerLink]="'/' + shareModel.urlPath['Admin Settings']" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Admin Management' | translate}}">
                <i class="fa fa-cog" aria-hidden="true"></i>
                <span translate>Admin Management</span>
              </a>
            </li>
            <ng-template #MspAdmin>
              <li *ngIf="isAdmin && isMsp">
                <a [routerLink]="'/management/admin/pro/' + mspManagement" [routerLinkActive]="['is-active']"
                  tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Admin Management' | translate}}" [ngClass]="{'is-active': mspActive}">
                  <i class="fa fa-cog" aria-hidden="true"></i>
                  <span translate>Admin Management</span>
                </a>
              </li>
            </ng-template>
            <li *ngIf="isAdmin && isSuperAdmin">
              <a [routerLink]="'/' + shareModel.urlPath.GatewayAdmin" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Gateway Management' | translate}}">
                <div class="fa-stack">
                  <i class="fa fa-window-minimize fa-stack-1x"></i>
                  <i class="fa fa-sitemap fa-stack-1x"></i>
                </div>
                <span translate>Gateway Management</span>
              </a>
            </li>
            <li *ngIf="isAdmin && !isMsp && isMspLoaded">
              <a [routerLink]="'/' + shareModel.urlPath.LicenseMgtList" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'License Management' | translate}}">
                <i class="fa fa-barcode" aria-hidden="true"></i>
                <span translate>License Management</span>
              </a>
            </li>
            <li *ngIf="isSuperAdmin">
              <a [routerLink]="'/' + shareModel.urlPath.APIManagement" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'API Management' | translate}}">
                <i class="fa fa-key" aria-hidden="true"></i>
                <span translate>API Management</span>
              </a>
            </li>
            <li *ngIf="isAdmin">
              <a [routerLink]="'/' + shareModel.urlPath.DeviceMgtList" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Device Management' | translate}}">
                <i class="fa fa-cube" aria-hidden="true"></i>
                <span translate="">Device Management</span>
              </a>
            </li>
            <li *ngIf="isAdmin">
              <a [routerLink]="'/' + shareModel.urlPath.DeviceMonitoringList" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Device Monitoring' | translate}}">
                <i class="fa fa-th-list" aria-hidden="true"></i>
                <span translate="">Device Monitoring</span>
              </a>
            </li>
            <li *ngIf="isAdmin">
              <a [routerLink]="'/' + shareModel.urlPath.EventMonitoring" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Event Monitoring' | translate}}">
                <i class="fa fa-table" aria-hidden="true"></i>
                <span translate>Event Monitoring</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="management" *ngIf="(isAdmin && isMspLoaded && isMsp) && !isSuperAdmin">
          <ul *ngIf="isAdmin" [ngClass]="showAdminHeader ? 'showAdminHeader' : 'hideAdminHeader'">
            <li class="navigation-header">
              <a data-bs-toggle="collapse" href="#collapseManagement" role="button" aria-expanded="true" aria-controls="collapseManagement">
                {{'PRO Management'| translate}}
                <i class="fa fa-sort-desc" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
          <ul class="collapse show" id="collapseManagement">
            <li>
              <a [routerLink]="'/' + shareModel.urlPath.ProManagementOverview" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Overview' | translate}}">
                <i class="fa fa-eye" aria-hidden="true"></i>
                <span translate>Overview</span>
              </a>
            </li>
            <li>
              <a [routerLink]="'/' + shareModel.urlPath.ProManagementCompany" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Company Management' | translate}}">
                <i class="fa fa-sitemap" aria-hidden="true"></i>
                <span translate>Company Management</span>
              </a>
            </li>
            <li>
              <a [routerLink]="'/' + shareModel.urlPath.ProManagementAccount" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Account Management' | translate}}">
                <i class="fa fa-user" aria-hidden="true"></i>
                <span translate>Account Management</span>
              </a>
            </li>
            <li>
              <a [routerLink]="'/' + shareModel.urlPath.ProDeviceManagement" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Device Management' | translate}}">
                <i class="fa fa-th-list" aria-hidden="true"></i>
                <span translate>Device Management</span>
              </a>
            </li>
            <li>
              <a [routerLink]="'/' + shareModel.urlPath.ProEventMonitoring" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Event Monitoring' | translate}}">
                <i class="fa fa-table" aria-hidden="true"></i>
                <span translate>Event Monitoring</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="monitoring">
          <ul>
            <li *ngIf="isAdmin" class="navigation-divider"></li>
            <li translate *ngIf="isAdmin" class="navigation-header">Monitoring</li>
            <ng-container *ngIf="packageStatus as package; else loading">
              <li *ngIf="package[shareModel.PackageList.Dashboard]?.Value == '1'">
                <a [routerLink]="'/' + shareModel.urlPath.Dashboard" [routerLinkActive]="['is-active']"
                  tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Dashboard' | translate}}">
                  <i class="fa fa-th-list" aria-hidden="true"></i>
                  <span translate="">Dashboard</span>
                </a>
              </li>
              <li *ngIf="!powerMaster && ((this.planInfo !== undefined && this.planInfo.Level >= smartPowerReportPlan.level && this.planInfo.NodeTotal >= smartPowerReportPlan.nodes) || isMsp)">
                <a [routerLink]="'/' + shareModel.urlPath['SmartPowerReportList']" [routerLinkActive]="['is-active']"
                  tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Smart Power Report' | translate}}">
                  <div class="fa-stack">
                    <i class="fa fa-file-o fa-stack-1x"></i>
                    <i class="fa fa-bar-chart fa-stack-1x"></i>
                  </div>
                  <span translate="">Smart Power Report</span>
                </a>
              </li>
              <li *ngIf="package[shareModel.PackageList.GlobalMap]?.Value == '1'">
                <a [routerLink]="'/' + shareModel.urlPath['Global Map']" [routerLinkActive]="['is-active']"
                  tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Global Map' | translate}}">
                  <i class="fa fa-globe" aria-hidden="true"></i>
                  <span translate>Global Map</span>
                </a>
              </li>
              <li *ngIf="package[shareModel.PackageList.FloorMap]?.Value == '1'">
                <a [routerLink]="'/' + shareModel.urlPath['Floor Map']" [routerLinkActive]="['is-active']"
                  tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Device Map' | translate}}">
                  <i class="fa fa-map-o" aria-hidden="true"></i>
                  <span translate>Device Map</span>
                </a>
              </li>
              <li *ngIf="package[shareModel.PackageList.EventLogs]?.Value == '1'">
                <a [routerLink]="'/' + shareModel.urlPath['Event Logs']" [routerLinkActive]="['is-active']"
                  tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Event Logs' | translate}}">
                  <i class="fa fa-table" aria-hidden="true"></i>
                  <span translate>Event Logs</span>
                </a>
              </li>
              <li *ngIf="package[shareModel.PackageList.StatusLogs]?.Value == '1'">
                <a [routerLink]="'/' + shareModel.urlPath['Status Logs']" [routerLinkActive]="['is-active']"
                  tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Status Logs' | translate}}">
                  <i class="fa fa-line-chart" aria-hidden="true"></i>
                  <span translate>Status Logs</span>
                </a>
              </li>
              <li *ngIf="package[shareModel.PackageList.EnergyUse]?.Value == '1'">
                <a [routerLink]="'/' + shareModel.urlPath['Energy Use']" [routerLinkActive]="['is-active']"
                  tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Energy Use' | translate}}">
                  <i class="fa fa-bolt" aria-hidden="true"></i>
                  <span translate="">Energy Use</span>
                </a>
              </li>
              <li *ngIf="package[shareModel.PackageList.AlertSetting]?.Value == '1'">
                <a [routerLink]="'/' + shareModel.urlPath['Alert Setting']" [routerLinkActive]="['is-active']"
                  tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Alert Settings' | translate}}">
                  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                  <span translate>Alert Settings</span>
                </a>
              </li>
              <li *ngIf="package[shareModel.PackageList.LicenseSetting]?.Value == '1'">
                <a [routerLink]="'/' + shareModel.urlPath.LicenseSetting" [routerLinkActive]="['is-active']"
                  tooltipStyleClass="sidebar_tooltip" pTooltip="{{'License Setting' | translate}}">
                  <i class="fa fa-barcode" aria-hidden="true"></i>
                  <span translate>License Setting</span>
                </a>
              </li>
              <!-- Issue #895 正機關閉 Companion 頁面 -->
              <li *ngIf="!isProd && displayCompanion">
                <a [routerLink]="'/' + shareModel.urlPath['Companion']" [routerLinkActive]="['is-active']"
                  tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Companion' | translate}}">
                  <i class="fa fa-laptop" aria-hidden="true"></i>
                  <span translate>Companion</span>
                </a>
              </li>
            </ng-container>
            <ng-template #loading>
              <!-- Loading stuff... -->
              <i class="fa fa-spinner fa-pulse fa-fw"></i>
            </ng-template>
            <li>
              <a [routerLink]="'/' + shareModel.urlPath.DeviceSetting" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Device Settings' | translate}}">
                <i class="fa fa-cube" aria-hidden="true"></i>
                <span translate="">Device Settings</span>
              </a>
            </li>
            <li *ngIf="!powerMaster && !isMsp && isMspLoaded">
              <a [routerLink]="'/' + shareModel.urlPath.PlanSetting" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Plan Settings' | translate}}">
                <div class="fa-stack">
                  <i class="fa fa-file-o fa-stack-1x"></i>
                  <i class="fa fa-check fa-stack-1x"></i>
                </div>
                <span translate>Plan Settings</span>
              </a>
            </li>
            <li *ngIf="!powerMaster">
              <a [routerLink]="'/' + shareModel.urlPath.GatewaySetting" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Gateway Settings' | translate}}">
                <div class="fa-stack">
                  <i class="fa fa-window-minimize fa-stack-1x"></i>
                  <i class="fa fa-sitemap fa-stack-1x"></i>
                </div>
                <span translate>Gateway Settings</span>
              </a>
            </li>
            <li *ngIf="!powerMaster && !isMsp && isMspLoaded">
              <a [routerLink]="'/' + shareModel.urlPath.PurchaseHistory" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Purchase History' | translate}}">
                <div class="fa-stack">
                  <i class="fa fa-file-o fa-stack-1x"></i>
                  <i class="fa fa-usd fa-stack-1x"></i>
                </div>
                <span translate>Purchase History</span>
              </a>
            </li>
            <li class="hidden-lg hidden-md" *ngIf="!powerMaster">
              <a herf="#" class="accountSetting" [routerLink]="'/account-info'" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Account Info' | translate}}">
                <i class="pi pi-user" aria-hidden="true"></i>
                <span translate>Account Info</span>
              </a>
            </li>
            <li class="hidden-lg hidden-md" *ngIf="powerMaster">
              <a herf="#" class="accountSetting" (click)="showChangePasswordDialog();" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Account Setting' | translate}}">
                <i class="pi pi-user" aria-hidden="true"></i>
                <span translate>Account Setting</span>
              </a>
            </li>
            <li class="hidden-lg hidden-md">
              <a herf="#" class="accountSetting" (click)="showLanguageDialog();" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" tooltipStyleClass="sidebar_tooltip" pTooltip="{{'Preferences' | translate}}">
                <i class="pi pi-cog" aria-hidden="true"></i>
                <span translate>Preferences</span>
              </a>
            </li>
            <li *ngIf="!powerMaster">
              <a [routerLink]="'/' + shareModel.urlPath.About" [routerLinkActive]="['is-active']"
                tooltipStyleClass="sidebar_tooltip" pTooltip="{{'About' | translate}}">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <span translate="">About</span>
              </a>
            </li>

          </ul>
        </div>
      </nav>
    </p-scrollPanel>
    <div class="chart" *ngIf="!powerMaster" [ngClass]="{'hide': !chartData }">
      <p-chart type="pie" [data]="data" [options]="options" width="200" height="200" [plugins]="plugins"></p-chart>
    </div>
    <div class="cplogo fixed-bottom" *ngIf="!powerMaster">
      <img src="../assets/images/logo_cyberpower.png">
    </div>
    <!-- <div class="cplogo ODMlogo fixed-bottom" *ngIf="powerMaster">
    <img class="img-responsive" src="../assets/images/microsoft_PNG10.png">
  </div> -->
  </aside>

<div class="companion-alert animate__animated" [ngClass]="{'show animate__fadeInDown': displayCompanionAlert , 'd-none': !displayCompanionAlert && !closeDisplayCompanionAlert, 'animate__fadeOutUp': closeDisplayCompanionAlert && displayCompanion}">
  <i class="fa fa-bell animate__animated animate__infinite animate__swing"></i>
  <strong>{{'ALERT' | translate}}!</strong>
  <span>{{'Companion Rule have occurred,' | translate}}</span>
  <a [routerLink]="'/companion'" style="text-decoration: underline !important;">{{'click here for details.' | translate}}</a>
  <a class="close" (click)="closeCompanionAlert()"><i class="pi pi-times"></i></a>
</div>
</div>
<div class="layout-overlay" (click)="mobilemenuBtn()"></div>

<!-- Cookies -->
<p-dialog header="{{'Cookies Consent' | translate}}" [(visible)]="displayCookiesDialog" [modal]="true" [closable]="false" [style]="{'width': '450px'}" class="ConfirmDialog cookieBox" [baseZIndex]="10000">
  <div class="dialog-content">
    <p>
      <span translate>This site uses cookies to provide you with a more responsive and personalized service. By using this site you agree to our use of cookies. Learn more about our</span> <a href="https://www.cyberpower.com/tw/zh/policy/cookie" target="_blank" translate>Cookies Policy</a>
    </p>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Got it' | translate}}" (click)="acceptCookies()" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Confirm -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmDialog" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog" [baseZIndex]="999999">
  <div class="dialog-content">
    <p translate>Do you really want to log out this site?</p>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="logout()" class="{{Confirm_button}}"></button>
    <button type="button" pButton (click)="displayConfirmDialog=false" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Smart Power Report -->
<p-dialog header="{{'Report' | translate}}" [(visible)]="displayReportCheckDialog" [modal]="true" [closable]="false" [width]="450" [responsive]="true" class="ConfirmDialog setup" [baseZIndex]="10000" [blockScroll]="true">
  <div class="dialog-content">
    <div class="icon circle">
      <span class="fa-stack fa-lg">
        <img src="../assets/images/img_smartPowerReport.png" alt="Smart Power Report"> 
      </span>
    </div>
    <div class="content-info">
      <h5 translate>Smart Power Report is ready to view</h5>
      <p *ngIf="latestSmartPowerReportType == 0 else CheckMonthReport">
        <span translate>Your Weekly Smart Power Report is ready. View now!</span>
      </p>
      <ng-template #CheckMonthReport>
        <span translate>Your Monthly Smart Power Report is ready. View now!</span>
      </ng-template>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Later' | translate}}" (click)="checkReportRedirct('later')" class="p-button-secondary"></button>
    <button type="button" pButton (click)="checkReportRedirct('check')" label="{{'Check Report' | translate}}" class="ui-button-danger"></button>
  </ng-template>
</p-dialog>

<!-- Account -->
<p-dialog class="accountSetting" header="{{accountSettingHeader | translate}}" [(visible)]="displayChangePasswordDialog" [modal]="true" [style]="{'width': '450px'}"[baseZIndex]="10000">
  <div class="dialog-content">
    <div class="form-group">
      <label>{{'Account ID' | translate}}<small>({{'Email Address' | translate}})</small></label>
      <input type="text" class="form-control pInputText" pInputText [(ngModel)]="ChangePasswordInfo.Account" disabled>
    </div>
    <!--    <div class="form-group" *ngIf="false">-->
    <!--      <label translate>Package</label>-->
    <!--      <div class="package" [ngClass]="{'morePackage': this.packageInfo.Waiting}">-->
    <!--        <input type="text" class="form-control pInputText" pInputText [ngModel]="ChangePasswordInfo.Package | translate" disabled>-->
    <!--        <div class="day">{{packageInfo?.RemainDays || '' }} <span *ngIf="this.packageInfo.RemainDays">{{'days' | translate}}</span></div>-->
    <!--        <a class="moreIcon" data-toggle="collapse" href="#morePackage" role="button" aria-expanded="true" aria-controls="morePackage" *ngIf="this.packageInfo.Waiting">-->
    <!--          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>-->
    <!--        </a>-->
    <!--      </div>-->
    <!--      <div class="collapse" id="morePackage" style="margin: 10px 0 0 0">-->
    <!--        <ul class="alert alert-warning">-->
    <!--          <li>-->
    <!--            <span class="title">{{'Next Package' | translate}} : </span>-->
    <!--            <span>{{packageInfo?.Waiting || ''}}</span>-->
    <!--          </li>-->
    <!--        </ul>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="form-group" *ngIf="!powerMaster">
      <label translate>Plan</label>
      <div class="package">
        <input type="text" class="form-control pInputText" pInputText [ngModel]="ChangePasswordInfo.Package | translate" disabled>
        <div class="day">{{packageInfo?.RemainDays || '' }} <span *ngIf="this.packageInfo.RemainDays">{{'days' | translate}}</span></div>
      </div>
    </div>
    <div *ngIf="powerMaster">
      <div class="form-group">
        <label translate>Old Password</label>
        <input type="password" pPassword id="Oldpassword" class="form-control pInputText" [(ngModel)]="ChangePasswordInfo.Password"
          #oldPassword="ngModel">
        <p-message severity="error" text="{{'Password is required' | translate}}"
          *ngIf="(this.ChangePasswordButton_dirty && !oldPassword.value)"></p-message>
      </div>
      <div class="form-group">
        <label translate>New Password</label>
        <input type="password" pPassword class="form-control pInputText" [(ngModel)]="ChangePasswordInfo.NewPassword"
          #newPassword="ngModel">
        <p-message severity="error" text="{{'New Password is required' | translate}}"
          *ngIf="(this.ChangePasswordButton_dirty && !newPassword.value)"></p-message>
      </div>
      <div class="form-group">
        <label translate="">Confirm New Password</label>
        <input type="password" pPassword class="form-control pInputText" [(ngModel)]="ConfirmPassword" #confirmPassword="ngModel">
        <p-message severity="error" text="{{'Password does not match' | translate}}"
          *ngIf="(confirmPassword.value!=newPassword.value && this.ChangePasswordButton_dirty) || (confirmPassword.value!=newPassword.value && confirmPassword.touched)">
        </p-message>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="changePassword()" label="{{'Save' | translate}}" class="{{Confirm_button}}" *ngIf="powerMaster"></button>
    <button type="button" pButton (click)="displayChangePasswordDialog=false;" label="{{'Cancel' | translate}}"
      class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Preferences -->
<p-dialog class="" header="{{'Preferences' | translate}}" [(visible)]="displayPreferencesDialog" [modal]="true" [resizable]="false" [style]="{'width': '450px'}" [baseZIndex]="10000">
  <div class="dialog-content">
    <div class="form-group">
      <label translate>Language</label>
      <div class="select">
        <p-select [options]="languageOptions" [(ngModel)]="selectedLanguage"></p-select>
      </div>
    </div>
    <div class="form-group">
      <label>{{'Date Format' | translate}}</label>
      <div class="select">
        <p-select [options]="dateFormatOptions" [(ngModel)]="selectedDateFormat"></p-select>
      </div>
    </div>
    <div class="form-group">
      <label>{{'Temperature Unit' | translate}}</label>
      <div class="select">
        <p-select [options]="temperatureUnitOptions" [(ngModel)]="selectedTemperatureUnit"></p-select>
      </div>
    </div>
    <div class="form-group type">
      <label>{{'Default Home Page' | translate}}</label>
    </div>
    <div class="form-group">
      <div class="row coordinate">
        <div class="col-list">
          <p-radiobutton name="defaultHomePage" value="0" [(ngModel)]="selectDefaultHomePage"></p-radiobutton>
          <label for="defaultHomePage" translate>Grid View</label>
        </div>
        <div class="col-list">
          <p-radiobutton name="defaultHomePage" value="3" [(ngModel)]="selectDefaultHomePage"></p-radiobutton>
          <label for="defaultHomePage" translate>Small Grid View</label>
        </div>
        <div class="col-list">
          <p-radiobutton name="defaultHomePage" value="2" [(ngModel)]="selectDefaultHomePage"></p-radiobutton>
          <label for="defaultHomePage" translate>List View</label>
        </div>
        <div class="col-list">
          <p-radiobutton name="defaultHomePage" value="1" [(ngModel)]="selectDefaultHomePage" [disabled]="disabledGlobalMapOpt"></p-radiobutton>
          <label for="defaultHomePage" translate>Global Map</label>
        </div>
      </div>
      
    </div>
    <div class="form-group type" *ngIf="!powerMaster">
      <div class="flex">
        <div>
          <label>{{'Account Summary - Dashboard' | translate}}</label>
          <small>{{'Summary on Dashboard' | translate}}</small>
        </div>
        <p-toggleswitch [(ngModel)]="summaryDashboardchecked"></p-toggleswitch>
      </div>
    </div>
    <div class="form-group type" *ngIf="!powerMaster">
      <div class="flex">
        <div>
          <label>{{'Account Summary - Email' | translate}}</label>
          <small>{{'Send Summary Email' | translate}}</small>
        </div>
        <p-toggleswitch [(ngModel)]="summaryEmailchecked"></p-toggleswitch>
      </div>
    </div>
    <div class="form-group type" *ngIf="!powerMaster">
      <div class="select">
        <p-multiSelect [options]="summaryRangeOptions" [disabled]="!summaryEmailchecked" [filter]="false" [showToggleAll]="false" [showHeader]="false" [(ngModel)]="selectedSummaryRange"
          placeholder="{{'Choose' | translate}}" appendTo="body"></p-multiSelect>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="savePreferences()" label="{{'Save' | translate}}" class="{{Confirm_button}}"></button>
    <button type="button" pButton (click)="displayPreferencesDialog=false;DefaultPreferences()" label="{{'Cancel' | translate}}"
      class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Contact Us -->
<p-button id="ContactUs" icon="fa fa-envelope" class="p-button-rounded {{Confirm_button}} comments" [ngClass]="{'margin': contactUsMargin}" (click)="showContanctBox();" *ngIf="!powerMaster && menuControl"></p-button>
<p-drawer [(visible)]="contactSidebar" position="bottom" [baseZIndex]="10000" class="contactBox" [modal]="false" header="{{'Contact CyberPower' | translate}}">
  <div class="content-body">
    <div class="form-group">
      <label [ngClass]="{'error': (dialogSaveDirty && ContactUsInput.category.length === 0)}">{{'Category' | translate}} <span>*</span></label>
      <div class="select">
        <p-select [options]="categoryOptions" [style]="{'width':'100%'}" [(ngModel)]="ContactUsInput.category" [ngClass]="{'ng-dirty ng-invalid': (dialogSaveDirty && ContactUsInput.category.length
          === 0)}"></p-select>
      </div>
    </div>
    <div class="form-group">
      <label [ngClass]="{'error': (dialogSaveDirty && !ContactUsInput.msg)}">{{'Message' | translate}} <span>*</span></label>
      <textarea [rows]="5" pTextarea [(ngModel)]="ContactUsInput.msg" [ngClass]="{'ng-dirty ng-invalid': (dialogSaveDirty && !ContactUsInput.msg)}"></textarea>
      <p translate>
        Describe your questions. The more details you provide, the better we can understand your situations.
      </p>
    </div>
  </div>
  <div class="content-foot">
    <button pButton type="submit" label="{{'Send' | translate}}" class="{{Confirm_button}}" (click)="onSubmitContanct();"></button>
  </div>
</p-drawer>

<app-dialog></app-dialog>
<app-summary *ngIf="!powerMaster && hideDashboardSummary && asideView" [showSummary]="showSummary" [selectedLanguage]="selectedLanguage"></app-summary>
<p-toast [style]="{marginTop: '70px'}"></p-toast>
